import Vue from 'vue'
import TurbolinksAdapter from 'vue-turbolinks'
import Calendar from '../calendar/app.vue'
import FullCalendar from 'vue-full-calendar'
const moment = require('moment')
require('moment/locale/de')
Vue.use(require('vue-moment'), { moment })
moment.locale('de');
Vue.use(FullCalendar)
import { BootstrapVue } from 'bootstrap-vue'

Vue.use(BootstrapVue)
import 'fullcalendar/dist/fullcalendar.css';
Vue.use(TurbolinksAdapter)

document.addEventListener('turbolinks:load', () => {
  let element = document.getElementById('calendar-js')
  if (element != null) {
    var vueapp = new Vue({
      el: '#calendar-js',
      template: '<App/>',
      render: h => h(Calendar, {
        props: {
          events: JSON.parse(element.dataset.events)
        }
      }),
    });
  }
});
